<template>
    <v-card class="mt-2 ml-4" max-width="344">
        <v-list-item three-line>
            <v-list-item-content>
                <v-list-item-title class="headline mb-1">
                    <input
                      class="input"
                      :value="participant.name"
                      placeholder="naam"
                      @blur="e => { updateName(participant, e.target.value) }"
                    >
                </v-list-item-title>
                <v-list-item-subtitle>
                    <input
                        class="input"
                        :value="participant.info"
                        placeholder="info"
                        @blur="e => { updateInfo(participant, e.target.value) }"
                    >
                </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action>
                <settings-button :options="settingsOptions" v-on:chosen="handleSettingsChoice"></settings-button>
            </v-list-item-action>
            <participant-poule :participantId="participant.id"></participant-poule>
        </v-list-item>
    </v-card>
</template>

<script>
/**
 * Er zit nog een edt-poule in. Die moet weg.
 */

import ParticipantModel from '@/models/ParticipantModel';
import ParticipantPoule from '@/components/ParticipantPoule';
import PouleModel from '@/models/PouleModel';
import SettingsButton from '@/components/SettingsButton';

export default {
  name: 'Participant',

  components: {
    ParticipantPoule,
    SettingsButton
  },

  props: {
    participant: {
      type: Object,
      required: false,
      default: function () { console.log('Got a new one'); return new ParticipantModel(); }
    }
  },

  data: () => ({
    settingsOptions: [
      { title: 'another', method: 'another' },
      { title: 'Verwijder', method: 'deleteParticipant' },
    ]
  }),

  computed: {
    poules () {
      return PouleModel.query().orderBy('order', 'asc').get();
    }
  },

  methods: {
    updateName (object, value) {
      value = value.trim();
      if (value !== object.name) {
        console.log('updateName to', value);
        object.$update({name: value});
      }
    },
    updateInfo (object, value) {
      value = value.trim();
      if (value !== object.info) {
        console.log('updateInfo', value);
        object.$update({info: value});
      }
    },
    handleSettingsChoice: function (settingChoice) {
      console.log('settingChoice', settingChoice);

      switch (settingChoice) {
        case 'deleteParticipant':
          // @todo: do a check if really can be removed!
          if (this.participant.matches > 0) {
            console.log('Cannot be removed');
            return;
          };
          if (confirm('Weet je het zeker?') === true) {
            ParticipantModel.delete(this.participant.id);
          }
          break;
        default:
          console.log('Settingchoice not defined', settingChoice);
      }
    },
    // below is not used anymore, but leave it for later reference
    editObject: function () {
      // never edit the Vuex-orm object directly!, so make a clone
      this.data = this.participant.$toJson();
      // clone the object https://www.samanthaming.com/tidbits/70-3-ways-to-clone-objects
      // this.data = { ...this.participant };
      this.editing = true;
    },
    saveObject: function () {
      if (this.participant.$id) {
        console.log('update', this.data);
        ParticipantModel.update({
          where: this.participant.id,
          data: this.data
        }).then(update => {
          console.log('successfully updated', update);
        });
      } else {
        console.log('insert', this.data);
        ParticipantModel.insert({
          data: this.data
        }).then(added => {
          console.log('succesfully added', added);
        });
      }
      this.data = {};
      this.editing = false;
      this.$emit('stop-editing');
    },
    cancelEdit: function () {
      this.editing = false;
      this.$emit('stop-editing');
    }
  },

  mounted () {
  }

};
</script>
